export default __webpack_public_path__ + "static/media/missionmobile.1dc6f472.png";